import { defineComponent as r, createBlock as n, openBlock as a, unref as l, mergeProps as p, withCtx as m, createElementVNode as i } from "vue";
import { RevIcon as c } from "@ds/components/Icon";
const u = /* @__PURE__ */ r({
  name: "IconAvatarFilled",
  __name: "IconAvatarFilled",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(t) {
    const o = t;
    return (s, e) => (a(), n(l(c), p(o, { "view-box": "0 0 24 24" }), {
      default: m(() => [...e[0] || (e[0] = [
        i("path", { d: "M12 3.25a4.75 4.75 0 1 0 0 9.5 4.75 4.75 0 0 0 0-9.5m-4 11A4.75 4.75 0 0 0 3.25 19v.5a1.25 1.25 0 0 0 1.25 1.25h15a1.25 1.25 0 0 0 1.25-1.25V19A4.75 4.75 0 0 0 16 14.25H8" }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  u as default
};
